module.exports = __webpack_public_path__ + "img/Weapon_177.ee8e807c.png";